module.exports = __webpack_public_path__ + "img/banner_3.3129854b.jpg";